import React from "react";
import logoStoom from "assets/logo-stoom.png";

/**
 * @Name: CompanyLogoComponent
 * @Data: 2023
 * @Desc: Cabecalho do Sistema
 */

interface CompanyLogoComponentProps {
  src?: string
}

const CompanyLogoComponent = ({ src }: CompanyLogoComponentProps) => {

  return (
    <React.Fragment>
      <div className="CompanyLogoComponent">
        <img alt="" src={src ?? logoStoom} height={60} />
      </div>
    </React.Fragment>
  );
};

export default CompanyLogoComponent;
